(() => {
  if (customElements.get('sher-sale-countdown')) return;
  class SherSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.anchor = Date.parse(this.dataset.anchor);
      if (!Number.isFinite(this.anchor)) this.anchor = Date.UTC(2026, 9, 16, 7);
      this.update = () => {
        const cycle = 86400000;
        const elapsed = ((Date.now() - this.anchor) % cycle + cycle) % cycle;
        const remaining = Math.ceil((cycle - elapsed) / 1000);
        this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        this.minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
        this.seconds.textContent = String(remaining % 60).padStart(2, '0');
      };
      this.update();
      this.interval = window.setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      window.clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.update);
    }
  }
  customElements.define('sher-sale-countdown', SherSaleCountdown);
})();
